import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./list-snippet-item.module.css";
import cx from "classnames";
import { ArrowRight } from "../../../assets/arrow-right";
export var ListSnippetItem = function(param) {
    var _smallImage = param.smallImage, smallImage = _smallImage === void 0 ? false : _smallImage, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, heading = param.heading, snippet = param.snippet, linkText = param.linkText, href = param.href, image = param.image, alt = param.alt, handleTrackEvent = param.handleTrackEvent, customIcon = param.customIcon;
    var handleLinkTrackingEvent = function() {
        handleTrackEvent();
    };
    var _obj, _obj1;
    return /*#__PURE__*/ _jsx("li", {
        className: cx((_obj = {}, _define_property(_obj, styles.containerWithoutImage, !image), _define_property(_obj, styles.container, image), _define_property(_obj, styles.containerWithSmallImage, smallImage), _obj)),
        children: !image ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: styles.heading,
                    children: heading
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: styles.snippet,
                    children: [
                        snippet,
                        " "
                    ]
                }),
                /*#__PURE__*/ _jsxs("a", {
                    href: href,
                    className: styles.link,
                    onClick: handleLinkTrackingEvent,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.linkText,
                            children: [
                                linkText,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.icon,
                            children: /*#__PURE__*/ _jsx(ArrowRight, {})
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                !isMobile ? /*#__PURE__*/ _jsx("div", {
                    className: cx((_obj1 = {}, _define_property(_obj1, styles.imageContainerSmall, smallImage), _define_property(_obj1, styles.imageContainer, !smallImage), _obj1)),
                    children: /*#__PURE__*/ _jsx("a", {
                        href: href,
                        onClick: handleLinkTrackingEvent,
                        children: /*#__PURE__*/ _jsx("img", {
                            src: image,
                            alt: alt,
                            className: styles.image
                        })
                    })
                }) : null,
                linkText ? /*#__PURE__*/ _jsxs("div", {
                    className: styles.textContainer,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: styles.heading,
                            children: heading
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: styles.snippet,
                            children: [
                                snippet,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({
                            href: href
                        }, customIcon && {
                            target: "_blank"
                        }), {
                            className: styles.link,
                            onClick: handleLinkTrackingEvent,
                            children: [
                                linkText,
                                " ",
                                /*#__PURE__*/ _jsx("div", {
                                    className: cx(styles.icon, _define_property({}, styles.customIcon, customIcon)),
                                    children: customIcon ? customIcon : /*#__PURE__*/ _jsx(ArrowRight, {})
                                })
                            ]
                        }))
                    ]
                }) : /*#__PURE__*/ _jsx("div", {
                    className: styles.textContainer,
                    children: /*#__PURE__*/ _jsx("a", {
                        href: href,
                        className: styles.linkHeading,
                        onClick: handleLinkTrackingEvent,
                        children: heading
                    })
                })
            ]
        })
    });
};
